var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49992 0.333313C3.81992 0.333313 0.833252 3.31998 0.833252 6.99998C0.833252 10.68 3.81992 13.6666 7.49992 13.6666C11.1799 13.6666 14.1666 10.68 14.1666 6.99998C14.1666 3.31998 11.1799 0.333313 7.49992 0.333313ZM2.16659 6.99998C2.16659 4.05331 4.55325 1.66665 7.49992 1.66665C8.73325 1.66665 9.86658 2.08665 10.7666 2.79331L3.29325 10.2666C2.5611 9.3354 2.16418 8.18457 2.16659 6.99998ZM7.49992 12.3333C6.26658 12.3333 5.13325 11.9133 4.23325 11.2066L11.7066 3.73331C12.4387 4.66456 12.8357 5.81539 12.8333 6.99998C12.8333 9.94665 10.4466 12.3333 7.49992 12.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNope);
export default __webpack_public_path__ + "static/media/ic-nope.b36aa44eedef2def71f0cd861ebc0a72.svg";
export { ForwardRef as ReactComponent };